var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.value,
            direction: "rtl",
            size: "1100px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.value = $event
            },
          },
        },
        [
          _c("search-page", {
            ref: "searchPage",
            attrs: {
              "column-count": 3,
              immediate: false,
              "form-data": _vm.formData,
              columns: _vm.columns,
              request: _vm.getList,
            },
            scopedSlots: _vm._u([
              {
                key: "page-operation",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "mb8" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.handleAdd },
                          },
                          [_vm._v("新增代码位")]
                        ),
                        _c("el-button", {
                          attrs: {
                            size: "small",
                            type: "text",
                            icon: "el-icon-refresh",
                          },
                          on: { click: _vm.refreshList },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "table-codeInfo",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "acea-row row-middle" }, [
                      _c("div", [_vm._v("代码位ID：" + _vm._s(row.id || "-"))]),
                      _c("div", [
                        _vm._v("代码ID：" + _vm._s(row.codeId || "-")),
                      ]),
                    ]),
                  ]
                },
              },
              {
                key: "table-status",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "开启",
                            "inactive-text": "关闭",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleStatusChange(row)
                            },
                          },
                          model: {
                            value: row.status,
                            callback: function ($$v) {
                              _vm.$set(row, "status", $$v)
                            },
                            expression: "row.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "table-append",
                fn: function () {
                  return [
                    _c("el-table-column", {
                      attrs: {
                        fixed: "right",
                        label: "操作",
                        align: "center",
                        "min-width": "220",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑代码位" : "新增代码位",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            "close-on-click-modal": false,
            width: "800px",
            "before-close": _vm.closeEdit,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: {
                rules: _vm.formRules,
                model: _vm.form,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "代码位名称：", prop: "codeName" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: { placeholder: "请输入代码位名称" },
                    model: {
                      value: _vm.form.codeName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "codeName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.codeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属应用", prop: "applicationId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      on: { change: _vm.changeApp },
                      model: {
                        value: _vm.form.applicationId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "applicationId", $$v)
                        },
                        expression: "form.applicationId",
                      },
                    },
                    [
                      _vm._l(_vm.appOptions, function (item, index) {
                        return [
                          _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.label,
                              value: item.value,
                              disabled: item.disabled,
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "广告类型：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        disabled: "",
                        size: "small",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.adType,
                        callback: function ($$v) {
                          _vm.adType = $$v
                        },
                        expression: "adType",
                      },
                    },
                    _vm._l(_vm.typeOptions, function (item, idx) {
                      return _c("el-option", {
                        key: idx,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "广告平台：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        disabled: "",
                        size: "small",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.platform,
                        callback: function ($$v) {
                          _vm.platform = $$v
                        },
                        expression: "platform",
                      },
                    },
                    _vm._l(_vm.platformOptions, function (item, idx) {
                      return _c("el-option", {
                        key: idx,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "广告商：", prop: "outPlatform" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: { size: "small", placeholder: "请选择" },
                      model: {
                        value: _vm.form.outPlatform,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "outPlatform", $$v)
                        },
                        expression: "form.outPlatform",
                      },
                    },
                    _vm._l(_vm.outPlatformOptions, function (item, idx) {
                      return _c("el-option", {
                        key: idx,
                        attrs: {
                          label: item.label,
                          value: item.value,
                          disabled: item.disabled,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "代码ID：", prop: "codeId" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: { placeholder: "请输入代码位ID" },
                    model: {
                      value: _vm.form.codeId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "codeId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.codeId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "status" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "开启",
                      "inactive-text": "关闭",
                      width: 35,
                    },
                    model: {
                      value: _vm.form.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "status", $$v)
                      },
                      expression: "form.status",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: 1000,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.loading, type: "primary" },
                      on: { click: _vm.submit },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }